import type { FC } from 'react';

import { DynamicImage } from '@wwe-portal/ui/components/dynamic-image';
import { Each } from '@wwe-portal/ui/components/utils';
import { cn } from '@wwe-portal/ui/lib/lib';

import type { OfferCardProps } from '../type';

const ROW_GAP = 8;
const MAX_COL = 2;

export const OfferItemGrid: FC<{
  items: OfferCardProps['items'];
  className?: string;
  maxCellHeight: number;
  maxCellWidth: number;
  columnGap: number;
  quantityClassName?: string;
  imageClassName?: string;
  totalItems?: number;
}> = ({
  items,
  className,
  maxCellHeight,
  maxCellWidth,
  columnGap,
  quantityClassName,
  imageClassName,
  totalItems,
}) => {
  const itemLen = items?.length ?? 1;
  return (
    <div
      className={cn('grid place-content-center', className)}
      style={{
        gridTemplateColumns: `repeat(${itemLen < 3 ? itemLen : MAX_COL}, minmax(0, 1fr))`,
        gridTemplateRows: `repeat(${itemLen < 3 ? 1 : 2}, minmax(0, 1fr))`,
        maxWidth: maxCellWidth * itemLen + (itemLen - 1) * 16,
        columnGap,
        rowGap: ROW_GAP,
        maxHeight:
          Math.ceil(itemLen / 2) * maxCellHeight +
          (Math.ceil(itemLen / 2) - 1) * ROW_GAP,
      }}
    >
      {items && (
        <Each
          data={items}
          render={(item) => {
            const isMore = item.text?.includes('MORE');
            return (
              <div
                className={cn(
                  'flex h-full w-full flex-col items-stretch justify-end gap-0.5'
                )}
                key={item.itemId}
              >
                <div className={cn('relative grow-0', imageClassName)}>
                  <DynamicImage
                    alt={item.itemId}
                    className={cn(
                      'absolute inset-0 size-full object-contain object-bottom'
                    )}
                    defaultUrl={item.defaultImageUrl}
                    dynamicUrl={item.dynamicImageUrl}
                    resizedWidth={64}
                  />
                </div>

                <span
                  className={cn(
                    'drop-shadow-text-2 stroke-2 text-center font-semibold leading-none text-white',
                    quantityClassName
                  )}
                >
                  {isMore && totalItems != null
                    ? `+${totalItems - itemLen} more`
                    : item.text}
                </span>
              </div>
            );
          }}
        />
      )}
    </div>
  );
};
